<div>
  <h3>Ihr Benutzer wurde gelöscht!</h3>
  <button routerLink="/login" class="btn btn-block form-control">
    zurück zum Login
  </button>
</div>
